import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import "./--sideEffects";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { App } from "./App";
import { NamedComponent } from "Views/NamedComponents";

function getEmbeddedProps(element: HTMLElement, id: string) {
  return JSON.parse(element.dataset[id]!);
}

function ComponentRouter({ element }: { element: HTMLElement }) {
  const componentName = element.dataset["reactComponent"];
  const props = getEmbeddedProps(element, "reactPropsJson");
  if (componentName) {
    return <NamedComponent ComponentName={componentName} Props={props} />;
  } else {
    const route = getEmbeddedProps(element, "reactRouteJson");
    return <App route={route} props={props} />;
  }
}

function renderAllReactRoots() {
  [...document.getElementsByClassName("react-rendered")].forEach(e =>
    ReactDOM.render(<ComponentRouter element={e as HTMLElement} />, e),
  );
}

renderAllReactRoots();
